import {FC, ReactNode} from 'react'
import {useInitSocketAuth} from '@/features/notifications/hooks/useInitSocketAuth'
import {useSocketNotifications} from '@/features/notifications/hooks/useSocketNotifications'
import {useExportsSocket} from '@/features/exports/hooks/useExportsSocket'
import {useSocketConversationMessages} from '@/features/conversations/hooks/useSocketConversationMessages'

interface NotificationsProviderProps {
    userId: string
    children: ReactNode
}

export const NotificationsProvider: FC<NotificationsProviderProps> = ({userId, children}) => {
    // Initialize socket authentication
    useInitSocketAuth()
    useSocketNotifications(userId)
    // Live async-export job status updates (reuses the already-joined users:{userId} room)
    useExportsSocket(userId)
    // Live "message deleted" updates for every conversation the user is a member of
    useSocketConversationMessages()

    return <>{children}</>
}
